import docCookies from './docCookies';

$(function(){

    // init lang
    const lang = $('html').attr('lang');

    // in case cookie is NOT set, show the modal
    if (docCookies.getItem('promo-video-hidden') === null ) {
        if (lang === 'de') {
            // trigger promo video delayed
            setTimeout(function(){
                $('.promo-video-trigger').trigger('click');
            },1500);
        }
    }

    // when closing the default modal, set cookie
    $(window).on('default-modal:closed',function(){
        // init
        var one_month_in_seconds = 2592000;
        // write cookie
        docCookies.setItem('promo-video-hidden', 'true', one_month_in_seconds, '/');
    })

});



// WEBPACK FOOTER //
// ./static/js/modules/promo-video.js